import type { ApiAppTypes } from "functions/api/[[route]]";
import { hc } from "hono/client";

export const apiClient = hc<ApiAppTypes>("/").api;
